import React, { useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";

import { parseQueryParams } from "../../../libs/Util";
import ActiveLearningLessons from "../../../templates/teacher/ActiveLearningLessons";
import {
  Context,
  fetchActiveLearningThemes,
  fetchActiveLearningAnswers,
  fetchActiveLearningMaterialLessonsData,
  fetchActiveLearningMaterialAnswers,
  fetchClassesByGrade,
  notFoundPath,
  fetchActiveLearningAnswersDownloadCsv,
} from "../../../teacherStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useDidMountEffect from "../../../hooks/useDidMountEffect";

import styles from "./ActiveLearningLessonPage.module.scss";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const material_code = parseQueryParams()["code"];
  const class_ids = parseQueryParams()["classList"];
  const history = useHistory();
  const { no } = useParams();

  const csvLinkRef = useRef<
    CSVLink & HTMLAnchorElement & { link?: HTMLAnchorElement }
  >(null);

  if (
    state.available_item_codes.length === 0 ||
    !state.available_item_codes.includes(material_code)
  ) {
    history.push(notFoundPath);
    return null;
  }

  const handleDownloadActiveLearningAnswersCsv = () => {
    !calling &&
      dispatch(
        peep(fetchActiveLearningAnswersDownloadCsv(class_ids, material_code)),
      );
  };

  useEffect(() => {
    dispatch(fetchActiveLearningThemes());
    dispatch(fetchClassesByGrade());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchActiveLearningAnswers(class_ids));
  }, [dispatch, class_ids]);

  useEffect(() => {
    dispatch(fetchActiveLearningMaterialLessonsData());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchActiveLearningMaterialAnswers(material_code));
  }, [dispatch, material_code]);

  useDidMountEffect(() => {
    const timeout = setTimeout(() => {
      state.active_learning_answers_csv?.length &&
        csvLinkRef.current?.link &&
        csvLinkRef.current.link.click();
    });
    return () => clearTimeout(timeout);
  }, [csvLinkRef, state.active_learning_answers_csv]);

  return (
    <div className={styles.wrapper}>
      <ActiveLearningLessons
        materialCode={material_code}
        lessonNo={Number(no)}
        calling={calling}
        onDownloadActiveLearningAnswersCsv={
          handleDownloadActiveLearningAnswersCsv
        }
      />
      {state.active_learning_answers_csv && (
        <CSVLink
          ref={csvLinkRef}
          filename="実践編全Lesson回答一覧.csv"
          data={state.active_learning_answers_csv}
          uFEFF
          hidden
        />
      )}
    </div>
  );
};
